/**
 * List of possible Brands.
 */
export enum Brands {
  Athleta = "at",
  BananaRepublic = "br",
  BananaRepublicFactoryStore = "brfs",
  Gap = "gap",
  GapFactoryStore = "gapfs",
  OldNavy = "on",
}

/**
 * Defines Value Drawer Colors.
 */
export type ValueDrawer = {
  blu1: string;
  grn1: string;
  ylw1: string;
};

/**
 * Defines Inverse Colors.
 */
export type InverseColors = {
  b1: string;
  b2: string;
  g1: string;
  g2: string;
  r1?: string;
  err1?: string;
  inf1?: string;
  wrn1?: string;
  s1?: string;
};
/**
 * Defines requirements to declare a font.
 */
export type Font = {
  fontFamily: string;
  fontWeight?: number;
  fontStyle?: string;
  fontVariantLigatures?: string;
  WebkitFontSmoothing: string;
  MozOsxFontSmoothing: string;
};

export type BrandedFont = {
  fontFamily: string;
  fontVariantLigatures?: string;
  WebkitFontSmoothing: string;
  MozOsxFontSmoothing: string;
};

/**
 * Defines YZY Color.
 */
export type YzyColor = {
  b1: string;
};

/**
 * Defines ultimate shape for theme object.
 */
export type ThemeConfig<T extends Brands> = {
  name: string;
  brand: T;
  color: {[colorName: string]: string | unknown};
  font: {
    primary: Font;
    secondary: Font;
    tertiary?: Font;
  };
  brandFont: BrandedFont;
  brandFontAlt?: BrandedFont;
  yzy?: YzyColor;
};

/**
 * Default export
 */
export default Brands;
